import { useCallback, useEffect, useState } from "react";
import { supabase } from "../../lib/supabaseClient";
import type { BodyMeasurement } from "../../types/database";

const todayIso = () => new Date().toISOString().slice(0, 10);

export function useMeasurements() {
  const [history, setHistory] = useState<BodyMeasurement[]>([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    const { data } = await supabase
      .from("body_measurements")
      .select("*")
      .order("date", { ascending: false });
    setHistory(data ?? []);
    setLoading(false);
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  async function addMeasurement(values: {
    weight_kg: number | null;
    waist_cm: number | null;
    chest_cm: number | null;
    arm_cm: number | null;
    date?: string;
  }) {
    const { data: userData } = await supabase.auth.getUser();
    const { error } = await supabase.from("body_measurements").insert({
      user_id: userData.user!.id,
      date: values.date ?? todayIso(),
      weight_kg: values.weight_kg,
      waist_cm: values.waist_cm,
      chest_cm: values.chest_cm,
      arm_cm: values.arm_cm,
    });
    if (error) throw error;
    await load();
  }

  return { history, loading, addMeasurement };
}
